var DropSelect = require('sma.admin/components/dropdowns/dropselect')

class MultiSelect extends DropSelect {
	get events() {
		var events = super.events;
		
		return events;
	}

	initialize(options) {
		this.noDropdown = true;
		this.noDoneButton = true;
		this.editable = false;
		this.createButton = false;
		this.noCancelButton = true;
		this.showSelectControls = true;

		super.initialize(options);
	}

	populateFromSelectBox(options) {
		var items = [];

		this.$selectEl.find('option').each(function(i, item) {
			items.push({
				name: $(item).val(),
				text: $(item).text(),
				checked: $(item).is(':selected')
			});
		});

		options.items = items;
		
	}

}

module.exports = MultiSelect;

